export default __webpack_public_path__ + "static/media/cuban.e6fd2944.png";